import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

type MatButtonStyle = 'mat-button'|'mat-flat-button'|'mat-icon-button'|
                      'mat-raised-button'|'mat-stroked-button'|'mat-mini-fab'|
                      'mat-fab';

@Component({
  selector: 'tcc-progress-button',
  templateUrl: './progress-button.component.html',
  styleUrls: ['./progress-button.component.scss']
})
export class ProgressButtonComponent {

  readonly loaderDiameter = 16;

  @Input() buttonStyle: MatButtonStyle = 'mat-button';

  @Input() type: 'button'|'submit';
  @Input() color: string;
  @Input() disabled: boolean;
  @Input() loading: boolean;
  @Input() loadingType: ('determinate'|'indeterminate') = 'indeterminate';
  @Input() loadingProgress: number;
  @Input() width: string;

  @Output() click = new EventEmitter<any>();


  constructor() {}


  /**
   * Stop event propagation for the native 'click' event
   * to allow using the 'click' output EventEmitter
   * @param event The native click event
   */
  @HostListener('click', ['$event'])
  public onClick(event: any) {
    event.stopPropagation();
  }

  onButtonClick(event: any) {
    if (this.loading) {
      return;
    }

    this.click.emit(event);
  }

}
